import { CircularProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { blackBackArrowImage, masterCardLogoImage } from "../../assets";
import { invokeApi } from "../../bl_libs/invokeApi";
import ConfirmMove from "./components/Confirm-Make-Payment/ConfirmMakePayment";

function ConfirmComplete(props) {
  const [requestData, setRequestData] = useState();
  const [cards, setCards] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [errMessage, setErrMessage] = useState("");

  const pushUrl = (url) => {
    props.history.push(url);
  };

  const fetchRequestDetails = (req_Id) => {
    let requestObj = {
      path: "/api/customer/customer_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${req_Id}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);
      if (res.code === 200) {
        //check and verify status of request is 2 (pending acceptance)
        //if not redirect to listing request
        if (res.request.request_timeline_status !== 6) {
          pushUrl("/dashboard/my-requests");
          return;
        }
        setRequestData(res);
        fetchCardsList();
      } else {
        setErrMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  const fetchCardsList = () => {
    let requestObj = {
      path: "/api/customer/checking_card_exist",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {};
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res, "CARD RESPONSE");
      if (res.code === 200) {
        //store cards in state
        if (res.retrive_stripe_card) {
          setCards(res.retrive_stripe_card.data);
        }
      } else {
        // remain this empty
        setErrMessage(res.message);
      }
      setIsLoading(false);
    });
  };

  const confirmMove = (req_Id) => {
    let requestObj = {
      path: "/api/customer/end_move_confirmation",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let postData = {
      request_id: `${req_Id}`,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        props.history.push("/dashboard/my-requests/" + req_Id);
      } else {
        setErrMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    fetchRequestDetails(props.match.params.requestId);
  }, []);
  if (isLoading) {
    return (
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request DETAIL</span>
          </p>
          <div className="container-fluid">
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section id="content-wrapper" className="content-wrapper rating-page">
      <div className="container-fluid">
        <p className="small-text-bold page-title ">
          <img
            className="pointer-point"
            src={blackBackArrowImage}
            onClick={() => props.history.goBack()}
          />
          <span>Request DETAIL</span>
        </p>

        <div className="rating-wrapper mt-40 mt-m-30">
          <ConfirmMove
            errMessage={errMessage}
            confirmMove={confirmMove}
            requestData={requestData}
            cards={cards}
          />
        </div>
      </div>
    </section>
  );
}

export default withRouter(ConfirmComplete);
